import { OcmOperatorInfo, OcmPoi } from '../../../../stores/types/ocm.interface';
import { FinderResult, NetworkOption } from '../types';

/** Groups every site whose operator is missing or an OCM "unknown" placeholder */
export const UNKNOWN_NETWORK_ID = 0;

/** Operator name, hiding OCM placeholders like "(Unknown Operator)" */
export const getNetworkName = (operator?: OcmOperatorInfo | null) => {
  const title = operator?.Title?.trim();
  if (!title || /^\(.*unknown.*\)$/i.test(title)) return null;
  return title.replace(/^\((.*)\)$/, '$1');
};

export const getNetworkId = (poi: OcmPoi) =>
  poi.OperatorInfo && getNetworkName(poi.OperatorInfo) ? poi.OperatorInfo.ID : UNKNOWN_NETWORK_ID;

/** Networks present in the results, busiest first, with unlisted operators last */
export const getNetworkOptions = (results: FinderResult[]): NetworkOption[] => {
  const optionsById = results.reduce((acc, { poi, networkId }) => {
    const option = acc.get(networkId);
    acc.set(networkId, {
      id: networkId,
      name: option?.name ?? getNetworkName(poi.OperatorInfo),
      siteCount: (option?.siteCount ?? 0) + 1,
    });
    return acc;
  }, new Map<number, NetworkOption>());

  return Array.from(optionsById.values()).sort(
    (a, b) =>
      Number(a.id === UNKNOWN_NETWORK_ID) - Number(b.id === UNKNOWN_NETWORK_ID) ||
      b.siteCount - a.siteCount ||
      (a.name ?? '').localeCompare(b.name ?? ''),
  );
};

export const filterByNetworks = (results: FinderResult[], networkIds: number[]) => {
  if (!networkIds.length) return results;
  const selected = new Set(networkIds);
  return results.filter((result) => selected.has(result.networkId));
};
